import React from 'react';
import { Link } from 'react-router-dom';

import SignOutButton from '../SignOut';
import * as ROUTES from '../../constants/routes';

import { AuthUserContext } from '../Session';

const Navigation = () => (
  <div>
    <AuthUserContext.Consumer>
      {authUser =>
        authUser ? <NavigationAuth /> : <NavigationNonAuth />
      }
    </AuthUserContext.Consumer>
  </div>
);

const navHeight = '40px';

const linkStyle = {
  nav: {
    top: 0,
    left: 0,
    height: navHeight,
    width: '100%',
    backgroundColor: '#6290C8',
    //position: 'fixed',
  },
  li: {
    height: navHeight,
    display: 'table',
  },
  liLeft: {
    float: 'left',
    borderRight: '1px solid white',
  },
  liRight: {
    float: 'right',
    borderLeft: '1px solid white',
  },
  link: {
    color: 'white',
    textDecoration: 'none',
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  label: {
    display: 'table-cell',
    verticalAlign: 'middle',
    padding: 0,
    margin: 0,
  },
  button: {
    border: 'none',
    backgroundColor: '#6290C8',
    color: 'white',
    paddingLeft: '10px',
    paddingRight: '10px',
    margin: 0,
    fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;',
    fontSize: '15px',
  },
  ul: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    overflow: 'hidden',
  }
};

const NavigationAuth = () => (
  <nav style={linkStyle.nav}>
  <ul style={linkStyle.ul}>
    <li 
      style={Object.assign({},linkStyle.liLeft, linkStyle.li)}
    >
      <Link to={ROUTES.LANDING} style={linkStyle.link}>Landing</Link>
    </li>
    <li 
      style={Object.assign({},linkStyle.liLeft, linkStyle.li)}
    >
      <Link to={ROUTES.CLASSES} style={linkStyle.link}>Classes</Link>
    </li>
    <li 
      style={Object.assign({},linkStyle.liLeft, linkStyle.li)}
    >
      <Link to={ROUTES.ACCOUNT} style={linkStyle.link}>Account</Link>
    </li>
    {/*
    <li 
      style={Object.assign({},linkStyle.liLeft, linkStyle.li)}
    >
      <Link to={ROUTES.ADMIN} style={linkStyle.link}>Admin</Link>
    </li>
    */}
    <li 
      style={Object.assign({},linkStyle.liRight, linkStyle.li)}
    >
      <label style={linkStyle.label}>
        <SignOutButton buttonStyle={linkStyle.button}/>
      </label>
    </li>
  </ul>
  </nav>
);

const NavigationNonAuth = () => (
  <nav style={linkStyle.nav}>
  <ul style={linkStyle.ul}>
    <li
      style={Object.assign({},linkStyle.liLeft, linkStyle.li)}
    >
      <Link to={ROUTES.LANDING} style={linkStyle.link}>Landing</Link>
    </li>
    <li
      style={Object.assign({},linkStyle.liRight, linkStyle.li)}
    >
      <Link to={ROUTES.SIGN_IN} style={linkStyle.link}>Sign In</Link>
    </li>
  </ul>
  </nav>
);

export default Navigation;
